module.exports = __webpack_public_path__ + "img/0Q3A5798_L_BlackMatted.b0f14e59.jpg";